<template>
    <div>
        <div
            v-for="thread in threads"
            :key="thread.id"
            class="d-flex chat-history-item w-100"
        >
            <div
                class="d-flex flex-column w-100 position-relative"
                style="gap: var(--space-2)"
            >
                <div class="chat-title">
                    {{ thread.predicted_subject }}
                </div>
                <div class="chat-subtext d-flex flex-column flex-md-row">
                    {{ formatThreadTimestamp(thread) }}
                </div>
                <div class="d-none d-md-flex justify-content-end">
                    <button
                        class="btn btn-primary"
                        @click="handleViewClick(thread.id)"
                    >
                        {{ $t('common.actions.viewMessage') }}
                        <i class="fi fi-chat"></i>
                    </button>
                </div>

                <div
                    class="d-none d-md-flex justify-content-end position-absolute top-0 end-0"
                >
                    <IconButton
                        v-if="false"
                        preset="delete"
                        @click="handleDeleteClick(thread.id)"
                    />
                </div>
            </div>
            <div
                class="d-flex d-md-none justify-content-end"
                style="gap: var(--space-2)"
            >
                <button
                    class="icon-btn icon-btn-primary"
                    @click="handleViewClick(thread.id)"
                >
                    <i class="fi fi-chat"></i>
                </button>
                <IconButton
                    preset="delete"
                    @click="handleDeleteClick(thread.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import IconButton from '@/components/IconButton.vue';
import { usePattyStore } from '@/stores/patty';
import { formatLocalizedDateTime } from '@/utils/dateUtils';

/** Component for displaying conversation history items */
export default {
    name: 'PattyThreadList',
    components: {
        IconButton,
    },
    props: {},
    emits: ['deleteMessage', 'viewMessage'],

    data() {
        return {
            threads: [],
        };
    },

    methods: {
        getThreads() {
            const payload = {
                order_by: {
                    created_at: 'desc',
                },
            };

            this.$getData('openai/assistant-thread/read', payload).then(
                (response) => {
                    if (response.success) this.threads = response.data;
                    else if (response.message)
                        this.$alertStore.pushError(
                            this.$t('patty.alerts.fetchThreadsError')
                        );
                }
            );
        },

        /** Handles delete button click */
        handleDeleteClick(threadId) {
            this.$emit('deleteMessage', threadId);
        },

        /** Handles view button click */
        handleViewClick(threadId) {
            this.pattyStore.openThread(threadId);
        },

        /** Formats thread timestamp */
        formatThreadTimestamp(thread) {
            return formatLocalizedDateTime(
                thread.created_at,
                this.$userStore.effectiveLocale
            );
        },
    },

    mounted() {
        this.pattyStore = usePattyStore();
        this.getThreads();
    },
};
</script>

<style scoped>
.chat-history-item {
    padding-block: var(--space-4);
    gap: var(--space-3);
}

.chat-title {
    font-size: var(--size-4);
    font-weight: 700;
    line-height: 1.5;
    width: 80%;
}

.chat-subtext {
    font-size: 0.875rem;
    line-height: 1.43;
    font-weight: 400;
    color: var(--neutral-800);
}

@media only screen and (max-width: 767.98px) {
    .chat-title {
        font-size: 0.9375rem;
    }
}
</style>
